export const api = "https://clear-it.herokuapp.com";